module.exports = __webpack_public_path__ + "img/sho3.af3ba0f5.jpg";